<template>
  <div>
    <!-- Area dove verranno renderizzati i componenti delle schede -->
    <router-view />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import api from '../services/api';

const route = useRoute();
const botId = ref(null);
const workspaceId = computed(() => route.params.workspaceId);
const bot = ref(null);

const fetchBotDetails = async () => {
  try {
    const response = await api.get(`/workspaces/${workspaceId.value}/bots/${botId.value}`);
    bot.value = response.data.data;
  } catch (error) {
    Console.error('Errore nel caricamento dei dettagli del bot:', error);
  }
};

onMounted(() => {
  botId.value = route.params.id;
  fetchBotDetails();
});

// Sync localStorage.currentBot whenever bot details load/change (covers
// direct URL access, browser back/forward, and bot list clicks). Always
// dispatch botNameChanged so the header updates without a page reload.
watch(bot, (newVal) => {
  try {
    if (newVal && newVal._id) {
      const cur = JSON.parse(localStorage.getItem('currentBot') || '{}');
      if (cur.id !== newVal._id || cur.name !== newVal.name) {
        localStorage.setItem('currentBot', JSON.stringify({ id: newVal._id, name: newVal.name }));
        window.dispatchEvent(new Event('botNameChanged'));
      }
    }
  } catch (e) {
    // ignore
  }
});

// When navigating from one bot to another, BotEditor stays mounted but
// route.params.id changes — refetch.
watch(() => route.params.id, (newId) => {
  if (newId && newId !== botId.value) {
    botId.value = newId;
    fetchBotDetails();
  }
});
</script>

<style scoped>

@reference "../style.css";

.tab-link {
  @apply py-4 px-6 text-gray-400 border-b-2 border-transparent hover:text-white;
}
.router-link-exact-active {
  @apply text-cyan-400 border-cyan-400;
}
</style>